import { useEffect } from "react";
import { useUserStore } from "@/lib/stores/userStore";
import { socketConnection } from "@/lib/natsConnection";
import { toast } from "@/components/ui/use-toast";

export function GlobalNatsPositionStatusListener() {
  const userId = useUserStore((s) => s.user?.uid);

  useEffect(() => {
    if (!userId) {
      return;
    }
    const errorTopic = `private.${userId}.position.errors`;
    const successTopic = `private.${userId}.position.success`;
    let unsubscribeError: (() => void) | undefined;
    let unsubscribeSuccess: (() => void) | undefined;
    (async () => {
      unsubscribeError = await socketConnection.subscribe(
        errorTopic,
        (msg: any) => {
          let errorMsg = "Position error";
          if (typeof msg === "string") {
            try {
              const parsed = JSON.parse(msg);
              errorMsg = parsed?.error?.msg || parsed?.msg || errorMsg;
            } catch {
              errorMsg = msg;
            }
          } else if (typeof msg === "object" && msg !== null) {
            errorMsg = msg?.error?.msg || msg?.msg || errorMsg;
          }
          if (
            typeof errorMsg === "string" &&
            errorMsg.startsWith("order place error: ")
          ) {
            errorMsg = errorMsg.replace("order place error: ", "");
          }
          toast({
            title: "Order Error",
            description: errorMsg,
            variant: "destructive",
          });
        },
      );
      unsubscribeSuccess = await socketConnection.subscribe(
        successTopic,
        (msg: any) => {
          let successMsg = "Position opened successfully";
          if (typeof msg === "string") {
            try {
              const parsed = JSON.parse(msg);
              successMsg = parsed?.msg || successMsg;
            } catch {
              successMsg = msg;
            }
          } else if (typeof msg === "object" && msg !== null) {
            successMsg = msg?.msg || successMsg;
          }
          toast({
            title: "Order Success",
            description: successMsg,
            variant: "success",
          });
        },
      );
    })();
    return () => {
      if (typeof unsubscribeError === "function") {
        unsubscribeError();
      }
      if (typeof unsubscribeSuccess === "function") {
        unsubscribeSuccess();
      }
    };
  }, [userId]);

  return null;
}
